<template>
  <div class="income">
    <div class="income-nav">
      <div class="income-nav-title">
        <van-cell-group>
          <van-cell title="" :value="currentDate" is-link>
            <template #right-icon>
              <van-icon name="arrow-down" @click="showDatePicker = true" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <van-row class="income-nav-list" :gutter="20">
        <van-col v-for="item in list" :key="item.title" :span="8">
          <template v-if="item.filter && typeof item.filter === 'function'">
            <p>{{ item.filter(incomeCount[item.value]) || 0 }}</p>
          </template>
          <p v-else>{{ incomeCount[item.value] || 0 }}</p>
          <span>{{ item.title }}</span>
        </van-col>
      </van-row>
    </div>
    <List :page="page" @requestList="handleLoad">
      <!-- 订单列表 -->
      <OrderCell :orderList="orderList" :cellList="cellList">
        <template v-slot:order-footer="scoped">
          <div class="order-footer">
            <van-button
              size="small"
              @click="$router.push({ name: 'OrderDetails', query: { orderNo: scoped.item.orderNo, id: scoped.item.orderId } })"
            >
              查看订单
            </van-button>
          </div>
        </template>
      </OrderCell>
    </List>
    <!-- 日期选择器 -->
    <MonthPicker
      :currentDate.sync="currentDate"
      :showDatePicker.sync="showDatePicker"
      @changeDate="params = { ...params, ...$event }"
    />
  </div>
</template>

<script>
import MonthPicker from '@/components/date/monthPicker';
import OrderCell from '@/components/order/cell';
import List from '@/components/list';
import { IncomeList, IncomeCount as getIncomeCount } from '@/api/income';
import { currentMonth, getMonthStartTime, getMonthEndTime } from '@/utils';
import { profitType, money, profitOrderType } from '@/filters';
export default {
  components: { MonthPicker, OrderCell, List },
  data() {
    return {
      currentDate: currentMonth,
      showDatePicker: false,
      list: [
        { title: '总收益', value: 'allProfit', filter: money },
        { title: '成交人提成', value: 'submitOwnerRemind', filter: money },
        { title: '归属人提成', value: 'ownerRemind', filter: money },
        { title: '团队业绩提成', value: 'teamRemind', filter: money },
        { title: '底薪', value: 'baseSalary', filter: money }
      ],
      cellList: [
        { title: '收益金额', value: 'money', border: true, filter: money },
        { title: '订单编号', value: 'orderNo' },
        { title: '类型', value: 'type', filter: profitOrderType },
        { title: '创建时间', value: 'created' },
        { title: '受益人', value: 'adminName' },
        { title: '收益类型', value: 'profitType', filter: profitType }
      ],
      orderList: [],
      incomeCount: {},
      page: {
        currentPage: 1,
        currentCount: 10,
        totalCount: 0,
        totalPage: 0
      },
      params: {
        startTime: getMonthStartTime(currentMonth),
        endTime: getMonthEndTime(currentMonth)
      }
    }
  },
  watch: {
    params: {
      handler(newVal) {
        const params = {
          ...newVal,
          page: 1,
          count: this.page.currentCount
        };
        this.getIncomeList(params, true);
        this.getIncomeCount(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /**
     * 请求收益列表数据
     */
    handleLoad() {
      const params = {
        ...this.params,
        page: this.page.currentPage + 1,
        count: this.page.currentCount
      };
      this.getIncomeList(params);
    },
    /**
     * 获取收益列表
     */
    getIncomeList(params, isClean) {
      IncomeList(params).then((res) => {
        if (res.errcode === 0) {
          if (isClean) {
            this.orderList = res.data;
          } else {
            this.orderList = this.orderList.concat(res.data);
          }
          this.page = res.page;
        }
      });
    },
    /**
     * 获取收益统计
     */
    getIncomeCount(params) {
      getIncomeCount(params).then((res) => {
        if (res.errcode === 0) {
          this.incomeCount = res.data;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.income {
  &-nav { background-color: #fff; margin-bottom: 15px;
    &-title {
      .van-cell__value { color: #333; }
      .van-icon-arrow-down { line-height: 24px; margin-left: 10px; color: #969799; font-size: 20px; font-weight: bold; }
    }
    &-list { color: #333; display: flex; flex-wrap: wrap;
      .van-col { text-align: center; overflow: hidden; word-wrap:break-word; word-break:break-all;
        &:nth-of-type(-n +3) { position: relative;
          &::after {
            content: '';
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top: 1px solid #ebedf0;
            transform: scaleY(.5);
          }
        }
        p { font-size: 18px; margin: 10px 0 !important; }
        span { font-size: 12px; display: block; margin-bottom: 10px; }
      }
    }
  }
}
</style>